import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faImage, faVideo, faHeadphones, faFileAlt, faCropAlt } from '@fortawesome/free-solid-svg-icons';

const ComposerFilePreview = ({ filePreview, onRemoveFile, onEditImage, isDark }) => {
  if (!filePreview) return null;

  const renderIcon = () => {
    if (filePreview.type === 'image' && filePreview.url) {
      return (
        <div
          role="button"
          onClick={onEditImage}
          title="Hacer clic para editar imagen"
          style={{ cursor: 'pointer', position: 'relative' }}
        >
          <img
            src={filePreview.url}
            alt="Preview"
            style={{ width: '42px', height: '42px', objectFit: 'cover', borderRadius: '6px' }}
          />
        </div>
      );
    }
    if (filePreview.type === 'video') {
      return (
        <div className="bg-dark text-white rounded d-flex align-items-center justify-content-center" style={{ width: '42px', height: '42px' }}>
          <FontAwesomeIcon icon={faVideo} />
        </div>
      );
    }
    if (filePreview.type === 'audio') {
      return (
        <div className="rounded d-flex align-items-center justify-content-center" style={{ width: '42px', height: '42px', backgroundColor: '#ea580c', color: '#ffffff' }}>
          <FontAwesomeIcon icon={faHeadphones} />
        </div>
      );
    }
    return (
      <div className="rounded d-flex align-items-center justify-content-center" style={{ width: '42px', height: '42px', backgroundColor: '#8b5cf6', color: '#ffffff' }}>
        <FontAwesomeIcon icon={faFileAlt} />
      </div>
    );
  };

  const formatFileSize = bytes => {
    if (!bytes) return '';
    const mb = bytes / (1024 * 1024);
    if (mb < 1) {
      return `${(bytes / 1024).toFixed(0)} KB`;
    }
    return `${mb.toFixed(1)} MB`;
  };

  const getSubLabel = () => {
    const sizeStr = filePreview.size ? ` (${formatFileSize(filePreview.size)})` : '';
    if (filePreview.type === 'image') return `Foto lista para enviar${sizeStr} · Máx 5 MB`;
    if (filePreview.type === 'video') return `Video listo para enviar${sizeStr} · Máx 16 MB`;
    if (filePreview.type === 'audio') return `Audio listo para enviar${sizeStr} · Máx 16 MB`;
    return `Documento listo para enviar${sizeStr} · Máx 100 MB`;
  };

  return (
    <div
      className="p-2 px-3 border-bottom d-flex align-items-center justify-content-between"
      style={{
        backgroundColor: isDark ? '#182635' : '#f8fafc',
        borderColor: isDark ? '#233142' : '#e2e8f0'
      }}
    >
      <div className="d-flex align-items-center gap-2 overflow-hidden">
        {renderIcon()}
        <div className="d-flex flex-column">
          <span className="fw-semibold text-truncate" style={{ fontSize: '0.82rem', maxWidth: '300px' }}>
            {filePreview.name}
          </span>
          <small className="text-muted" style={{ fontSize: '0.72rem' }}>
            {getSubLabel()}
          </small>
        </div>
      </div>

      <div className="d-flex align-items-center gap-2 flex-shrink-0">
        {filePreview.type === 'image' && onEditImage && (
          <button
            type="button"
            className="btn btn-sm py-1 px-2.5 d-flex align-items-center gap-1.5 shadow-none fw-semibold rounded-pill"
            style={{
              fontSize: '0.74rem',
              backgroundColor: isDark ? 'rgba(56, 189, 248, 0.15)' : '#e0f2fe',
              color: isDark ? '#38bdf8' : '#0284c7',
              border: isDark ? '1px solid rgba(56, 189, 248, 0.35)' : '1px solid #bae6fd',
              cursor: 'pointer',
              transition: 'all 0.15s ease'
            }}
            onClick={onEditImage}
            title="Editar imagen (dibujar, recortar, rotar)"
          >
            <FontAwesomeIcon icon={faCropAlt} style={{ fontSize: '0.74rem' }} />
            <span>Editar imagen</span>
          </button>
        )}

        <button
          type="button"
          className="btn btn-sm btn-link text-danger p-1 shadow-none"
          onClick={onRemoveFile}
          title="Quitar archivo"
        >
          <FontAwesomeIcon icon={faTimes} />
        </button>
      </div>
    </div>
  );
};

ComposerFilePreview.propTypes = {
  filePreview: PropTypes.object,
  onRemoveFile: PropTypes.func.isRequired,
  onEditImage: PropTypes.func,
  isDark: PropTypes.bool
};

export default ComposerFilePreview;
